type LatencyTimeKeeper = {
  getMeasureDurationSecs: () => number;
  measureDurationAt: (index: number) => number;
};

export const MAX_AUDIO_OBSERVATION_AGE_MS = 1500;

export type AudioEventTiming = {
  source?: 'midi' | 'audio-recognition';
  observedAtMs?: number;
};

export const getEventInputLatencyMs = (
  baseInputLatencyMs: number,
  timing: AudioEventTiming,
  nowMs = Date.now(),
) => {
  if (timing.source !== 'audio-recognition') return 0;
  const normalizedBaseLatencyMs = Number.isFinite(baseInputLatencyMs)
    ? Math.max(0, baseInputLatencyMs)
    : 0;
  const observationAgeMs = Number.isFinite(timing.observedAtMs)
    ? Math.min(MAX_AUDIO_OBSERVATION_AGE_MS, Math.max(0, nowMs - (timing.observedAtMs as number)))
    : 0;
  return normalizedBaseLatencyMs + observationAgeMs;
};

export const getInputLatencyMeasureOffset = (
  timeKeeper: LatencyTimeKeeper | null | undefined,
  inputLatencyMs?: number | null,
) => {
  const latencyMs =
    typeof inputLatencyMs === 'number' && Number.isFinite(inputLatencyMs)
      ? Math.max(0, inputLatencyMs)
      : 0;
  if (!timeKeeper || latencyMs <= 0) return 0;

  const measureDurationSecs = timeKeeper.getMeasureDurationSecs();
  const measureFrac = timeKeeper.measureDurationAt(0);
  if (
    !Number.isFinite(measureDurationSecs) ||
    measureDurationSecs <= 0 ||
    !Number.isFinite(measureFrac) ||
    measureFrac <= 0
  ) {
    return 0;
  }

  return (latencyMs / 1000 / measureDurationSecs) * measureFrac;
};

export const getLatencyAdjustedMeasureTimestamp = (
  timestamp: number,
  timeKeeper: LatencyTimeKeeper | null | undefined,
  inputLatencyMs?: number | null,
) => timestamp - getInputLatencyMeasureOffset(timeKeeper, inputLatencyMs);
